(function () {
  function money(cents, currency) {
    var amount = Number(cents || 0) / 100
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
        maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
      }).format(amount)
    } catch (_error) {
      return '$' + amount.toFixed(amount % 1 === 0 ? 0 : 2)
    }
  }

  function setText(root, selector, value) {
    root.querySelectorAll(selector).forEach(function (element) {
      element.textContent = value
    })
  }

  function selectGalleryMedia(root, index) {
    root.querySelectorAll('[data-fixd-gallery-media]').forEach(function (media) {
      media.classList.toggle('is-active', media.dataset.fixdGalleryMedia === String(index))
    })
    root.querySelectorAll('[data-fixd-gallery-thumb]').forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb.dataset.fixdGalleryThumb === String(index))
    })
  }

  function activeThumbnailIndex(carousel, slideIndex) {
    var offset = Number(carousel.dataset.thumbnailSlideOffset || 0)
    var normalizedSlideIndex = Number(slideIndex || 0)

    if (normalizedSlideIndex < offset) {
      return carousel.dataset.thumbnailInitialIndex || '0'
    }

    return String(normalizedSlideIndex - offset)
  }

  function updateCarouselThumbnails(carousel, slideIndex) {
    var thumbnailIndex = activeThumbnailIndex(carousel, slideIndex)
    var carouselSelector = '#' + carousel.id

    document.querySelectorAll('[data-carouselid="' + carouselSelector + '"]').forEach(function (thumbnail) {
      var isActive = thumbnail.dataset.index === thumbnailIndex
      thumbnail.classList.toggle('is-active', isActive)
      thumbnail.classList.toggle('border-green', isActive)
    })
  }

  function initCarouselThumbnails(root) {
    root.querySelectorAll('[data-index][data-carouselid]').forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        var carousel = document.querySelector(thumbnail.dataset.carouselid)
        if (!carousel) return

        var slideIndex = Number(thumbnail.dataset.index || 0) + Number(carousel.dataset.thumbnailSlideOffset || 0)
        if (slideIndex < 0) slideIndex = 0
        updateCarouselThumbnails(carousel, slideIndex)
        if (carousel.splide) carousel.splide.go(slideIndex)
      })
    })
  }

  function applyClassList(element, classList, shouldAdd) {
    String(classList || '')
      .split(/\s+/)
      .filter(Boolean)
      .forEach(function (className) {
        element.classList.toggle(className, shouldAdd)
      })
  }

  function selectedVariantCartUrl(root, button, currentHref) {
    var variantId = button?.dataset.variantId
    if (!variantId) return currentHref

    var quantity = button.dataset.quantity || root.dataset.quantity || '1'
    var channel = button.dataset.cartChannel || root.dataset.cartChannel || 'buy_button'
    var baseUrl = button.dataset.cartBaseUrl || root.dataset.cartBaseUrl

    try {
      baseUrl = baseUrl || new URL(currentHref, window.location.href).origin
    } catch (_error) {
      baseUrl = window.location.origin
    }

    var url = new URL('/cart/' + encodeURIComponent(variantId) + ':' + encodeURIComponent(quantity), baseUrl)
    if (channel) url.searchParams.set('channel', channel)
    return url.toString()
  }

  function updateSelectedVariantLinks(root, button) {
    root.querySelectorAll('.sku-picker-selected-offer-cta[href], [data-fixd-selected-variant-url][href]').forEach(function (link) {
      link.href = selectedVariantCartUrl(root, button, link.href)
    })
  }

  function updateVariant(root, button) {
    if (!button) return

    var variantId = button.dataset.variantId
    var price = button.dataset.price
    var comparePrice = button.dataset.comparePrice
    var currency = button.dataset.currency || root.dataset.currency || 'USD'
    var packTier = button.dataset.packTier || '1'
    var discount = button.dataset.discount || '67'

    root.querySelectorAll('.fixd-pack-button').forEach(function (packButton) {
      var isSelected = packButton === button
      packButton.classList.toggle('is-selected', isSelected)
      packButton.classList.toggle('selected', isSelected)
      if (packButton.dataset.selectedClasses || packButton.dataset.unselectedClasses) {
        applyClassList(packButton, packButton.dataset.selectedClasses, isSelected)
        applyClassList(packButton, packButton.dataset.unselectedClasses, !isSelected)
      } else {
        packButton.classList.toggle('border-green', isSelected)
        packButton.classList.toggle('bg-green', isSelected)
        packButton.classList.toggle('text-white', isSelected)
        packButton.classList.toggle('border-grey-200', !isSelected)
        packButton.classList.toggle('bg-white', !isSelected)
        packButton.classList.toggle('text-black', !isSelected)
      }
      packButton.setAttribute('aria-pressed', isSelected ? 'true' : 'false')
    })

    root.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.value = variantId
    })

    setText(root, '[data-fixd-current-price]', money(price, currency))
    setText(root, '[data-fixd-compare-price]', comparePrice && Number(comparePrice) > 0 ? money(comparePrice, currency) : '')
    setText(root, '[data-fixd-discount]', discount)
    updateSelectedVariantLinks(root, button)

    root.querySelectorAll('[data-fixd-pack-image]').forEach(function (image) {
      var isSelected = image.dataset.fixdPackImage === packTier
      image.classList.toggle('is-active', isSelected)
      image.classList.toggle('hidden', !isSelected)
    })
  }

  function initBuyBox(root) {
    var firstSelected = root.querySelector('.fixd-pack-button.is-selected') || root.querySelector('.fixd-pack-button')
    updateVariant(root, firstSelected)

    root.querySelectorAll('.fixd-pack-button').forEach(function (button) {
      button.addEventListener('click', function () {
        updateVariant(root, button)
      })
    })

    root.querySelectorAll('[data-fixd-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        selectGalleryMedia(root, thumb.dataset.fixdGalleryThumb)
      })
    })

    initCarouselThumbnails(root)

    root.querySelectorAll('[data-fixd-direct-checkout="true"]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var returnTo = form.querySelector('input[name="return_to"]')
        if (returnTo) returnTo.value = '/checkout'
      })
    })
  }

  function initLazyVideos() {
    document.querySelectorAll('video[data-fixd-lazy-src]').forEach(function (video) {
      var load = function () {
        if (video.dataset.loaded === 'true') return
        var source = document.createElement('source')
        source.src = video.dataset.fixdLazySrc
        source.type = video.dataset.fixdLazyType || 'video/mp4'
        video.appendChild(source)
        video.dataset.loaded = 'true'
        video.load()
      }

      video.addEventListener('play', load, { once: true })
      video.closest('[data-fixd-video-card]')?.querySelector('button')?.addEventListener('click', function () {
        load()
        video.play()
      })
    })
  }

  function initSplideCarousels(attempt) {
    var splideConstructor = window.Splide
    var nextAttempt = Number(attempt || 0) + 1

    if (!splideConstructor) {
      if (nextAttempt <= 20) {
        window.setTimeout(function () {
          initSplideCarousels(nextAttempt)
        }, 100)
      }
      return
    }

    document.querySelectorAll('[data-fixd-splide]').forEach(function (carousel) {
      if (carousel.dataset.fixdSplideMounted === 'true') return

      var options = {}
      try {
        options = JSON.parse(carousel.dataset.splide || '{}')
      } catch (_error) {}

      var instance = new splideConstructor(carousel, options)
      carousel.splide = instance
      instance.on('mounted moved', function () {
        updateCarouselThumbnails(carousel, instance.index)
      })
      instance.mount()
      updateCarouselThumbnails(carousel, instance.index)
      carousel.dataset.fixdSplideMounted = 'true'
    })
  }

  function stopDialogVideo(dialog) {
    var iframe = dialog && dialog.querySelector('iframe')
    if (iframe) iframe.setAttribute('src', '')
  }

  function initReviewFilters() {
    document.querySelectorAll('.reviews-select').forEach(function (button) {
      button.addEventListener('click', function () {
        var targetSource = button.dataset.appSource
        var scope = button.closest('section') || document

        scope.querySelectorAll('.reviews-select').forEach(function (reviewButton) {
          reviewButton.classList.remove('border-white')
        })
        button.classList.add('border-b-2', 'border-white')

        scope.querySelectorAll('.review-container').forEach(function (review) {
          var shouldShow = targetSource === 'all' || review.dataset.reviewSource === targetSource
          review.classList.toggle('hidden', !shouldShow)
        })
      })
    })
  }

  function initReadMore() {
    document.querySelectorAll('[data-fixd-read-more]').forEach(function (button) {
      button.addEventListener('click', function () {
        var group = button.closest('.read-more') || button.closest('.group')
        if (group) group.classList.toggle('more')
      })
    })
  }

  function initYoutubeReviewModal() {
    document.querySelectorAll('[data-modal-cta="youtubeVideo"]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var videoId = trigger.dataset.youtubeId
        var dialog = document.querySelector('[data-modal-id="youtubeVideo"]')
        if (!videoId || !dialog) return

        var iframe = dialog.querySelector('iframe')
        if (!iframe) return

        iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(videoId)
        if (typeof dialog.showModal === 'function') {
          dialog.showModal()
        } else {
          dialog.setAttribute('open', '')
        }
      })
    })

    document.querySelectorAll('[data-modal-id="youtubeVideo"]').forEach(function (dialog) {
      dialog.addEventListener('mousedown', function (event) {
        if (event.target === dialog) {
          dialog.close()
          stopDialogVideo(dialog)
        }
      })

      dialog.addEventListener('close', function () {
        stopDialogVideo(dialog)
      })
    })

    document.querySelectorAll('[data-fixd-close-modal]').forEach(function (button) {
      button.addEventListener('click', function () {
        var dialog = button.closest('dialog')
        if (!dialog) return
        dialog.close()
        stopDialogVideo(dialog)
      })
    })
  }

  function initOdditVideoOverlays() {
    if (window.__fixdOdditVideoOverlayInited) return
    window.__fixdOdditVideoOverlayInited = true

    document.addEventListener('click', function (event) {
      var clickedButton = event.target.closest('.oddit-v2-video-play')
      var card = clickedButton ? clickedButton.closest('.oddit-v2-video-card') : event.target.closest('.oddit-v2-video-card')
      if (!card) return
      if (!clickedButton && event.target.closest('a, button')) return

      var button = card.querySelector('.oddit-v2-video-play')
      var video = card.querySelector('.oddit-v2-video')
      if (!video) return
      if (!clickedButton && video.controls) return

      document.querySelectorAll('.oddit-v2-video').forEach(function (otherVideo) {
        if (otherVideo !== video) {
          otherVideo.pause()
          otherVideo.controls = false
          otherVideo.closest('.oddit-v2-video-card')?.querySelector('.oddit-v2-video-play')?.classList.remove('hidden')
        }
      })

      video.controls = true
      video.play()
      button?.classList.add('hidden')
    })

    document.addEventListener(
      'pause',
      function (event) {
        if (!event.target.classList?.contains('oddit-v2-video')) return
        event.target.controls = false
        event.target.closest('.oddit-v2-video-card')?.querySelector('.oddit-v2-video-play')?.classList.remove('hidden')
      },
      true
    )

    document.addEventListener(
      'ended',
      function (event) {
        if (!event.target.classList?.contains('oddit-v2-video')) return
        event.target.controls = false
        event.target.closest('.oddit-v2-video-card')?.querySelector('.oddit-v2-video-play')?.classList.remove('hidden')
      },
      true
    )
  }

  function compatibilityResult(form) {
    var year = form.querySelector('.year-select')?.value || ''
    var make = form.querySelector('.make-select')?.value || ''
    var fuelType = form.querySelector('.fuel-type-select')?.value || ''
    var thresholds = { min: 1996, gas: 1996, diesel: 2008, hybrid: 2000 }

    try {
      thresholds = Object.assign(thresholds, JSON.parse(form.dataset.year || '{}'))
    } catch (_error) {}

    if (!year || !make || !fuelType) return null

    var vehicleYear = Number(year)
    if (vehicleYear < Number(thresholds.min)) return false
    if (fuelType === 'Gas' && vehicleYear < Number(thresholds.gas)) return false
    if (fuelType === 'Diesel' && vehicleYear < Number(thresholds.diesel)) return false
    if (fuelType === 'Hybrid' && vehicleYear < Number(thresholds.hybrid)) return false
    if (fuelType === 'Electric') return false

    return true
  }

  function initVehicleCompatibility() {
    document.querySelectorAll('.vehicle-compatibility-form').forEach(function (form) {
      var section = form.closest('.compatibility') || document
      var resultElement = section.querySelector('.compatibility-results')
      var compatibleText = section.querySelector('.compatible')
      var nonCompatibleText = section.querySelector('.not-compatible')
      var ctaContainer = section.querySelector('.cta-compatibility-container')

      var update = function () {
        var compatible = compatibilityResult(form)

        resultElement?.classList.toggle('text-green', compatible === true)
        compatibleText?.classList.toggle('hidden', compatible !== true)
        nonCompatibleText?.classList.toggle('hidden', compatible !== false)
        ctaContainer?.classList.toggle('hidden', compatible !== true)
      }

      form.addEventListener('change', update)
      update()
    })
  }

  function initVehicleCompatibilityModal() {
    var modal = document.getElementById('vehicleCompatibilityModal')
    if (!modal) return

    var openModal = function () {
      modal.classList.remove('hidden')
      modal.classList.add('flex')
      document.documentElement.classList.add('overflow-hidden')
    }

    var closeModal = function () {
      modal.classList.add('hidden')
      modal.classList.remove('flex')
      document.documentElement.classList.remove('overflow-hidden')
    }

    document.querySelectorAll('[data-fixd-vehicle-compatibility-open]').forEach(function (button) {
      button.addEventListener('click', openModal)
    })

    modal.querySelectorAll('[data-fixd-vehicle-compatibility-close]').forEach(function (button) {
      button.addEventListener('click', closeModal)
    })

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.classList.contains('hidden')) {
        closeModal()
      }
    })
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-fixd-shopify-buy-box]').forEach(initBuyBox)
    initLazyVideos()
    initSplideCarousels()
    initReviewFilters()
    initReadMore()
    initYoutubeReviewModal()
    initOdditVideoOverlays()
    initVehicleCompatibility()
    initVehicleCompatibilityModal()
  })
})()
